import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { IImageCategory, IImageLibrary } from "./types/_image";
import { PaginationResponse, ResponseData } from "./types/_public";
const api = new APIClient();

const path_image_library = '/images';
const imageApi = {
  postSiteImageCategory(dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `/image-sites`;
    return api.post(url, dataForm);
  },
  getImageSearchByCategory(params: any = {}): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `/image-sites`;
    return api.get(url, params)
  },
  postConvertToCdn(dataForm: any): Promise<AxiosResponse<ResponseData<IImageCategory>, any>> {
    const url = `/image-convert`;//`/utilities/convert-cdn`;
    return api.post(url, dataForm);
  },

  imageLibraries(params: any): Promise<AxiosResponse<ResponseData<IImageLibrary[]> & PaginationResponse, any>> {
    const url = `${path_image_library}`
    return api.get(url, params)
  },
  getImageLibrary(id: string | number, params: any = {}): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/${id}`;
    return api.get(url, params)
  },
  postImageLibrary(dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}`;
    return api.post(url, dataForm);
  },
  putImageLibrary(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/${id}`;
    return api.put(url, dataForm)
  },
  patchImageLibrary(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/${id}/download`;
    return api.patch(url, dataForm)
  },
  deleteImageLibrary(dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}`;
    return api.delete(url, {
      data: dataForm
    })
  },
  importImageBulkByExcel(dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/import-v2`;
    const formData = new FormData();
    if (dataForm.files) {
      formData.append('files', dataForm.files);
    }
    if (dataForm.email) {
      formData.append('email', dataForm.email);
    }
    return api.post(url, formData, {
      timeout: 1000 * 60 * 10,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
  },
  getTemplateSampleImageBulkExcel(params: any): Promise<AxiosResponse<ResponseData<IImageLibrary[]> & PaginationResponse, any>> {
    const url = `/masters/template-files/media-manage-import`
    return api.get(url, params)
  },
  getAllImageLibraryTags(params: any): Promise<AxiosResponse<ResponseData<IImageLibrary[]> & PaginationResponse, any>> {
    const url = `/masters/tags`
    return api.get(url, params)
  },
  postImageLibraryFavorite(id: string | number, dataForm: any): Promise<AxiosResponse<ResponseData<IImageLibrary>, any>> {
    const url = `${path_image_library}/${id}/favorite`;
    return api.post(url, dataForm)
  },
}
export default imageApi
